module.exports = __webpack_public_path__ + "static/media/green.e3893062.png";